// extracted by mini-css-extract-plugin
export var compactFilters = "_d1-4";
export var detailImage = "_d1-1";
export var dropdownContainer = "_d1-2";
export var imageContainer = "_d1-0";
export var selectedCard = "_d1-3";